//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import type {
	CvMtaModel,
	MidTermAdjustmentRatingResponse,
	MtaCancellationReason,
	MtaChangeType,
	PcMtaModel,
} from './api';

const URL = import.meta.env.VITE_API || `${window.location.origin}/api`;

export interface IMidTermAdjustmentClient {
	/**
	 * Take up Braintree MTA - Payment Method for MTA is sent
	 * @param body (optional)
	 * @return OK
	 */
	takeUpMidTermAdjustment(body: TakeUpBraintreeMidTermAdjustmentCommand | undefined): Promise<void>;

	/**
	 * Cancel an MTA using a four-part policy token
	 */
	cancelMidTermAdjustment(
		policyToken: string,
		transactionId: string,
		cancellationReason: MtaCancellationReason,
	): Promise<void>;
}

export class MidTermAdjustmentClient implements IMidTermAdjustmentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Take up Braintree MTA - Payment Method for MTA is sent
	 * @param body (optional)
	 * @return OK
	 */
	takeUpMidTermAdjustment(
		body: TakeUpBraintreeMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v2/MidTermAdjustment/TakeUpMidTermAdjustment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUpMidTermAdjustment(_response);
			});
	}

	protected processTakeUpMidTermAdjustment(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Cancel an MTA using a four-part policy token
	 * @return OK
	 */
	cancelMidTermAdjustment(
		policyToken: string,
		transactionId: string,
		cancellationReason: MtaCancellationReason,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v2/MidTermAdjustment/CancelMidTermAdjustment?';
		if (policyToken === undefined || policyToken === null)
			throw new globalThis.Error("The parameter 'policyToken' must be defined and cannot be null.");
		else url_ += 'PolicyToken=' + encodeURIComponent('' + policyToken) + '&';
		if (transactionId === undefined || transactionId === null)
			throw new globalThis.Error("The parameter 'transactionId' must be defined and cannot be null.");
		else url_ += 'TransactionId=' + encodeURIComponent('' + transactionId) + '&';
		if (cancellationReason === undefined || cancellationReason === null)
			throw new globalThis.Error("The parameter 'cancellationReason' must be defined and cannot be null.");
		else url_ += 'CancellationReason=' + encodeURIComponent('' + cancellationReason) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'DELETE',
			url: url_,
			headers: {},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCancelMidTermAdjustment(_response);
			});
	}

	protected processCancelMidTermAdjustment(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}
}

export interface TakeUpBraintreeMidTermAdjustmentCommand {
	/** Policy Reference */
	policyReference: string;
	/** The transaction id associated with the payment */
	transactionId: string;
	takeUpDetails: TakeUpDetails;
	/** Payment Id from the make payment intent endpoint */
	paymentId?: string | undefined;
	/** Guid from Payment Intent response */
	idempotencyKey?: string | undefined;
	/** Braintree Nonce */
	nonce?: string | undefined;
	/** Braintree Device Data */
	deviceData?: string | undefined;
	/** This is an existing payment method id (selected for an existing card). */
	existingCardPaymentMethodId?: string | undefined;
	/** Used to send postal documents */
	sendPostalDocuments?: boolean;
}

export enum PaymentMethods {
	CARD_PAYMENT = 'CARD_PAYMENT',
	DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export interface TakeUpDetails {
	/** Underwriting Response Id. */
	underwritingResponseId: string;
	/** Underwriting option Id. */
	underwritingOptionId: string;
	/** The selected payment option code. */
	paymentCollectionOptionCode: string;
	selectedBalanceSettlementMethod: PaymentMethods;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}

// Hand-extended for #69376 until swagger/v2 is regenerated from a deployed API that includes these actions.

export interface GetOrCreateCvMidTermAdjustmentByPolicyTokenCommand {
	policyToken: string;
	mtaStartDate: string;
	changeType: MtaChangeType[];
	transactionId?: string | undefined;
}

export interface RateCvMidTermAdjustmentByPolicyTokenCommand {
	policyToken: string;
	mtaStartDate: string;
	changeType: MtaChangeType[];
	midTermAdjustment: CvMtaModel;
}

export interface GetOrCreatePcMidTermAdjustmentByPolicyTokenCommand {
	policyToken: string;
	mtaStartDate: string;
	changeType: MtaChangeType[];
	transactionId?: string | undefined;
}

export interface RatePcMidTermAdjustmentByPolicyTokenCommand {
	policyToken: string;
	mtaStartDate: string;
	changeType: MtaChangeType[];
	midTermAdjustment: PcMtaModel;
}

export class CvMidTermAdjustmentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();
		this.baseUrl = baseUrl ?? URL;
	}

	getOrCreateCvMidTermAdjustment(
		body: GetOrCreateCvMidTermAdjustmentByPolicyTokenCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvMtaModel> {
		return this.putJson<CvMtaModel>('/api/v2/CvMidTermAdjustment/GetOrCreateCvMidTermAdjustment', body, cancelToken);
	}

	rateCvMidTermAdjustment(
		body: RateCvMidTermAdjustmentByPolicyTokenCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MidTermAdjustmentRatingResponse> {
		return this.putJson<MidTermAdjustmentRatingResponse>(
			'/api/v2/CvMidTermAdjustment/RateCvMidTermAdjustment',
			body,
			cancelToken,
		);
	}

	private putJson<T>(path: string, body: unknown, cancelToken?: CancelToken): Promise<T> {
		return putJson(this.instance, this.baseUrl + path, body, cancelToken);
	}
}

export class PcMidTermAdjustmentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();
		this.baseUrl = baseUrl ?? URL;
	}

	getOrCreatePcMidTermAdjustment(
		body: GetOrCreatePcMidTermAdjustmentByPolicyTokenCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PcMtaModel> {
		return this.putJson<PcMtaModel>('/api/v2/PcMidTermAdjustment/GetOrCreatePcMidTermAdjustment', body, cancelToken);
	}

	ratePcMidTermAdjustment(
		body: RatePcMidTermAdjustmentByPolicyTokenCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MidTermAdjustmentRatingResponse> {
		return this.putJson<MidTermAdjustmentRatingResponse>(
			'/api/v2/PcMidTermAdjustment/RatePcMidTermAdjustment',
			body,
			cancelToken,
		);
	}

	private putJson<T>(path: string, body: unknown, cancelToken?: CancelToken): Promise<T> {
		return putJson(this.instance, this.baseUrl + path, body, cancelToken);
	}
}

function putJson<T>(instance: AxiosInstance, url: string, body: unknown, cancelToken?: CancelToken): Promise<T> {
	const options_: AxiosRequestConfig = {
		data: body,
		method: 'PUT',
		url,
		headers: {
			'Content-Type': 'application/json-patch+json',
			Accept: 'application/json',
		},
		cancelToken,
	};

	return instance
		.request(options_)
		.catch((_error: any) => {
			if (isAxiosError(_error) && _error.response) {
				return _error.response;
			} else {
				throw _error;
			}
		})
		.then((_response: AxiosResponse) => processJsonResponse<T>(_response));
}

function processJsonResponse<T>(response: AxiosResponse): Promise<T> {
	const status = response.status;
	let _headers: any = {};
	if (response.headers && typeof response.headers === 'object') {
		for (const k in response.headers) {
			if (response.headers.hasOwnProperty(k)) {
				_headers[k] = response.headers[k];
			}
		}
	}
	if (status === 200) {
		return Promise.resolve<T>(response.data as T);
	} else if (status === 204) {
		return throwException('No Content', status, response.data, _headers);
	} else if (status === 400) {
		return throwException('Bad Request', status, response.data, _headers, response.data);
	} else if (status !== 200 && status !== 204) {
		return throwException('An unexpected server error occurred.', status, response.data, _headers);
	}
	return Promise.resolve<T>(null as any);
}
